import { useState, useContext } from 'react'
import './ReassignRecruiterModal.css';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { reassignRecruiter } from '../../apis/assignRecruiter/assignRecruiter';
import { NotificationContainer, NotificationManager } from "react-notifications";
import checkExistsRequisition from '../../apis/checkRequisitionExists/checkRequisitionExists';
import { UserTypeContext } from "../../AppRoute";
import { useLocation } from 'react-router-dom';
import DataTable from '../DataTable/DataTable';


function ReassignRecruiterModal(props) {
    const location = useLocation();

    const { userType, userRecords } = useContext(UserTypeContext);
    const idContextTest = userType === "Admin" ? location?.state?.id : userRecords?.id
    const userRecruitmentpartnerId = userType === "Admin" ? location?.state?.recruitmentPartnerId : userRecords?.recruitmentpartnerId
    const { openDialogRecruiterAssingment, setopenDialogRecruiterAssingment, teamInfo, setTeamInfo, recruiterOptions, setRecruiterOptions, setactiveRequAssign, activeRequAssign, selctedRecruiter, teamRecruiter, handleSubmit, setOpenDialog } = props
    const [openDialogconfirmation, setopenDialogconfirmation] = useState(false);
    const [openDialogRecruiterAssign, setDialogRecruiterAssign] = useState(false);
    const [defaultRecruiter, setDefaultRecruiter] = useState([]);
    const [reassignCheck, setreassignCheck] = useState(true);
    const [reassignCheckLoader, setreassignCheckLoader] = useState(false);
    const [reassignSaveCheck, setreassignSaveCheck] = useState(true);
    const [reassignDefaultCheck, setreassignDefaultCheck] = useState(false);
    const [isUserDataUpdating, setIsUserDataUpdating] = useState(false)


    const deleteRecruiterConfirm = async () => {
        setIsUserDataUpdating(true)
        await handleSubmit();
        setDialogRecruiterAssign(false)
        setopenDialogconfirmation(false)
        setIsUserDataUpdating(false)
        setreassignDefaultCheck(false)
        setDefaultRecruiter([])
    }


    const handelRecruiterEmailChange = (val, prop) => {
        let activeRequsition = [...activeRequAssign]
        for (let i = 0; i < activeRequsition.length; i++) {

            if (activeRequsition[i].requisitionDetailId === prop.requisitionDetailId) {
                activeRequsition[i].reasssingRecruiter = val
                break;
            }
        }
        setactiveRequAssign(activeRequsition)
    }


    const handleDialogRecruiterAssingment = () => {
        setopenDialogRecruiterAssingment(false);
        setDialogRecruiterAssign(true)
        setreassignSaveCheck(true)
        setreassignDefaultCheck(false)
        setDefaultRecruiter([])
    };
    const closeModalRecruiterAssign = () => {
        setDefaultRecruiter([])
        setDialogRecruiterAssign(false)
        setreassignDefaultCheck(false)
        setOpenDialog(true)
    };

    const handleCloseDialogRecruiterAssingment = () => {
        setopenDialogRecruiterAssingment(false);
        setOpenDialog(true)
    };

    const handleDefaultChange = (e, value) => {
        for (let i = 0; i < activeRequAssign.length; i++) {
            activeRequAssign[i].reasssingRecruiter = value
        }
        setDefaultRecruiter(value)
        setreassignCheck(false)
    }

    const handelCloseConfirmation = () => {
        setopenDialogconfirmation(false)
    }
    const handelChangeReassign = async () => {
        setreassignCheckLoader(true)

        const reassignList1 = []
        try {

            for (let i = 0; i < activeRequAssign.length; i++) {
                let payload = {
                    requisitionDetailId: activeRequAssign[i].requisitionDetailId,
                    requisitionId: activeRequAssign[i].requisitionId,
                    oldRceruiterId: activeRequAssign[i].recruiterId,
                    newRecruiterId: activeRequAssign[i].reasssingRecruiter.id,
                    "notificationList": [
                        {
                            "id": activeRequAssign[i].recruiterId,
                            "email": selctedRecruiter.email,
                            "displayName": selctedRecruiter.displayName,
                            "status": -1
                        },
                        {
                            "id": activeRequAssign[i].reasssingRecruiter.id,
                            "email": activeRequAssign[i].reasssingRecruiter.email,
                            "displayName": activeRequAssign[i].reasssingRecruiter.displayName,
                            "status": 0
                        }
                    ],
                    senderId: idContextTest,
                    reqreferenceId: activeRequAssign[i].requisitionDetail.reqreferenceId,
                    displayName: userRecords?.displayName,
                    recruitmentpartnerId: activeRequAssign[i].recruitmentpartnerId,
                    "istlnf": false,
                    teamId: teamInfo.teamId,
                    newRecruiterTeamId: teamInfo.teamId,
                }
                reassignList1.push(payload)
            }

            var response = ''
            for (let i = 0; i < reassignList1.length; i += 5) {
                let arr = (reassignList1.slice(i, i + 5));
                const payload = {
                    reassignList: arr,
                    userRecruitmentpartnerId: activeRequAssign[0].recruitmentpartnerId,
                    userId: idContextTest

                }
                let response1 = await reassignRecruiter(payload);
                response = response1;
            }

            if (response.status === 200) {
                NotificationManager.success(response.data.message, "Success", 10000);
                setreassignSaveCheck(false)
                setreassignCheck(true)
                setreassignCheckLoader(false)
                setreassignDefaultCheck(true)
            }
            else {
                NotificationManager.error("An unexpected error occurred", "Error", 10000);
                setreassignCheckLoader(false)
            }
        }
        catch (err) {
            NotificationManager.error("An unexpected error occurred", "Error", 10000);
            setreassignCheckLoader(false)
        }
    };
    const handelChangeReassignSave = async () => {
        let payload = {
            recruiterId: selctedRecruiter.id || activeRequAssign[0].recruiterId,
            recruitmentpartnerId: userRecruitmentpartnerId,
            validation: "RecruiterAssignedRequisition"
        }
        const dataRes = await checkExistsRequisition(payload);

        if (dataRes.status === 400 && dataRes.errorCode === 400) {
            const errorMessage = dataRes.data.message;
            NotificationManager.error(errorMessage, "Error", 10000);

        } else {
            const matchRecruiter = teamInfo.selectedRecruiter.filter((item) => item.id === selctedRecruiter.id)
            const newRecruiterOptions = teamInfo.selectedRecruiter.filter((item) => item.id !== selctedRecruiter.id)

            const newRecruiterid = teamInfo.selectedRecruiterId.filter((item) => item !== selctedRecruiter.id)
            setTeamInfo({ ...teamInfo, selectedRecruiter: newRecruiterOptions, selectedRecruiterId: newRecruiterid })
            setRecruiterOptions([...recruiterOptions, ...matchRecruiter])
            setopenDialogconfirmation(true)
        }
    };

    let columns = [
        {
            accessorKey: "requisitionDetail.reqreferenceId",
            header: "Reference Id",
            size: 80,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: "no_of_positions",
            header: "No of Positions*",
            size: 60,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: "",
            header: "Reassigned To",
            cell: ({ row }) => (
                <>
                    <td className='field-title-recruiter-reassign'> Reassigned To :</td>
                </>
            ),
            size: 80,
            enableSorting: false,
            enableColumnFilter: false,

        },
        {
            accessorKey: "",
            header: "Recruiter Email*",
            size: 170,
            enableSorting: false,
            enableColumnFilter: false,
            cell: ({ row }) => (
                <Autocomplete
                    id="combo-box-demo"
                    options={teamRecruiter}
                    getOptionLabel={(option) => option.email || ""}
                    value={row.original?.reasssingRecruiter || null}
                    disableClearable
                    onChange={(e, val) => handelRecruiterEmailChange(val, row.original)}
                    disabled={reassignDefaultCheck}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            height: 40,
                            paddingRight: '8px',
                        },
                        '& .MuiInputBase-input': {
                            height: '40px !important',
                            padding: '0 8px !important',
                        },
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Select Recruiter email"
                        />
                    )}
                />
            ),
        },
        {
            accessorKey: "",
            header: "Recruiter Name*",
            size: 120,
            enableSorting: false,
            enableColumnFilter: false,
            cell: ({ row }) => (
                <TextField
                    value={row.original?.reasssingRecruiter?.displayName || ""}
                    disabled
                    variant="outlined"
                    fullWidth
                    placeholder="Recruiter name"
                    className="access_search"
                />
            ),
        },
    ]


    return (
        <div className='' >
            <div className='' >
                <div>
                    <Dialog
                        open={openDialogRecruiterAssingment}
                        onClose={handleCloseDialogRecruiterAssingment}
                        aria-labelledby="dialog-title"
                        maxWidth="md"
                        fullWidth={true}
                        className="add-team"
                    >
                        <div className="team_dialog_modal" >
                            <div className='team-dialog-TitleContainer'>
                                <span className='dialog-title-text'>Confirm Recruiter Removal</span>
                            </div>
                        </div>
                        <DialogContent className="">
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-recruiter-dialog'>Recruiter assigned to an open or on-hold requisition. Do you still want to remove the recruiter?</Typography>

                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions className='dialog-actionbutton-team'>
                            <button onClick={handleCloseDialogRecruiterAssingment} className="cancel-button-team">
                                No
                            </button>
                            <button
                                className={isUserDataUpdating ? 'updateButton_team_disabled' : 'updateButton-team'}
                                onClick={handleDialogRecruiterAssingment}
                                disabled={isUserDataUpdating}
                            >
                                <span>yes</span>
                                {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton_team" />) : null}
                            </button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        onClose={closeModalRecruiterAssign}
                        fullScreen
                        aria-labelledby="customized-dialog-title"
                        maxWidth='xl'
                        open={openDialogRecruiterAssign}
                        className='dialogBox_assignRequisitio'
                    >
                        <DialogTitle id="customized-dialog-title" className="header" onClose={closeModalRecruiterAssign}>
                            <div className='header_top'>
                                Recruiter Reassignment
                            </div>
                        </DialogTitle>
                        <DialogContent className='assignRequisitionContaine'>

                            <div className='reassign_dialog_content'>
                                <Grid sx={{ width: '350px' }} >
                                    <Typography className='field-title-team-dialog'>Requisition Reassignment for :</Typography>
                                    <TextField variant="outlined" className='access_search' fullWidth value={selctedRecruiter.email} disabled={true} />

                                </Grid>

                                <Grid sx={{ width: '350px' }} >
                                    <div>

                                        <Typography className='field-title-team-dialog'>Default Reassigned Recruiter :</Typography>
                                        <Autocomplete
                                            id="combo-box-demo"
                                            value={defaultRecruiter.email}
                                            options={teamRecruiter || []}
                                            getOptionLabel={(option) => option.email}
                                            disableClearable
                                            disabled={reassignDefaultCheck}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: 40,
                                                    paddingRight: '8px',
                                                },
                                                '& .MuiInputBase-input': {
                                                    height: '40px !important',
                                                    padding: '0 8px !important',
                                                },
                                            }}
                                            onChange={handleDefaultChange}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="Select default recruiter first"
                                                />
                                            )}

                                        />
                                    </div>
                                </Grid>
                            </div>
                            {reassignCheckLoader &&
                                <div className="dialog-overlay">
                                    <div className="dialog-container">
                                        <div className="loader">
                                            <div className="spinner"></div>
                                        </div>
                                    </div>
                                </div>
                            }

                            <DataTable
                                data={activeRequAssign}
                                columns={columns}
                                isLoading={reassignCheckLoader}
                            />
                        </DialogContent>

                        <DialogActions className="dialog-actionbutton-Recruiter">


                            <button className="cancel-button-assignTeamLeader" onClick={closeModalRecruiterAssign}>
                                Cancel
                            </button>
                            <button
                                className={isUserDataUpdating ? 'updateButton-assignTeamLeader_disabled' : 'updateButton-assignTeamLeader'}
                                onClick={handelChangeReassign}
                                disabled={reassignCheck}
                            >
                                <span>Reassign</span>
                            </button>

                            <button
                                className={isUserDataUpdating ? 'updateButton-assignTeamLeader_disabled' : 'updateButton-assignTeamLeader'}
                                onClick={handelChangeReassignSave}
                                disabled={reassignSaveCheck}
                            >
                                <span>Save</span>
                            </button>



                        </DialogActions>

                    </Dialog>
                    <Dialog
                        open={openDialogconfirmation}
                        onClose={handelCloseConfirmation}
                        aria-labelledby="dialog-title"
                        maxWidth="md"
                        fullWidth={true}
                        className="add-team"
                    >
                        <div className="team_dialog_modal" >
                            <div className='team-dialog-TitleContainer'>
                                <span className='dialog-title-text'>Confirm Recruiter Removal</span>
                            </div>
                        </div>
                        <DialogContent className="">
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography className='field-title-recruiter-dialog'>Do you want to remove {selctedRecruiter.email} ?</Typography>

                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions className='dialog-actionbutton-team'>
                            <button onClick={handelCloseConfirmation} className="cancel-button-team">
                                No
                            </button>
                            <button
                                className={isUserDataUpdating ? 'updateButton_team_disabled' : 'updateButton-team'}
                                onClick={deleteRecruiterConfirm}
                                disabled={isUserDataUpdating}
                            >
                                <span>yes</span>
                                {isUserDataUpdating ? (<CircularProgress className="circularProgress_updateButton_team" />) : null}
                            </button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>


            <NotificationContainer />
        </div>
    )
}

export default ReassignRecruiterModal